export default __webpack_public_path__ + "static/Крысиные бега_1-8cd34be253fc245a711133d8fcb30a0b.jpg";